import React, { useEffect, useState } from 'react';
import { ValidationObj } from '../../../types/interface';
import validationUtils from '../../utils/validationUtils';
import { Form } from 'react-bootstrap';
import { capitalizeFirstLetter } from 'utils/helpers';
import './StandardCheckbox.scss';

interface Props {
  id?: string;
  label: string;
  isChecked: boolean;
  setChecked: (value: boolean) => void;
  disabled?: boolean;
  className?: string;
  showError?: boolean;
  validations?: ValidationObj[];
  onClick?: React.MouseEventHandler<HTMLElement>;
  onChange?: (value: boolean) => void;
  formGroupClassName?: string;
}

const StandardCheckbox = (props: Props) => {
  const [valid, setValid] = useState(false);
  const [errorText, setErrorText] = useState('');

  useEffect(() => {
    checkValidity(props.isChecked);
  }, []);

  useEffect(() => {
    checkValidity(props.isChecked);
  }, [props.validations, errorText, props.isChecked]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.setChecked) {
      props.setChecked(e.target.checked);
    }
    // props.onChange(e)
  };

  const checkValidity = (value: string | number | boolean) => {
    let isValid = true;
    let errorText = '';
    for (const validation of props.validations || []) {
      if (validation.type != 'checkFormValidity') {
        if (
          !validation.disabled &&
          !validationUtils[validation.type](value, validation)
        ) {
          errorText = validation.message;
          isValid = false;
          break;
        }
      }
    }
    setValid(isValid);
    setErrorText(errorText);
  };

  return (
    <>
      <Form.Group
        className={`mb-3 text-start ${props.formGroupClassName}`}
        id="standard-checkbox"
      >
        <div className="form-icon-container d-flex align-items-center ">
          <Form.Check
            id={props.id}
            className={`${props.disabled ? '' : 'cursor-pointer'}  ${
              props.className
            }`}
            disabled={props.disabled || false}
            checked={props.isChecked}
            onChange={handleChange}
            readOnly={props.disabled}
            onClick={props.onClick}
          />
          <div
            className={`fs-14 line-height-21 ms-2 ${
              props.disabled ? '' : 'cursor-pointer'
            } `}
            onClick={() =>
              !props.disabled && props.setChecked?.(!props.isChecked)
            }
          >
            {capitalizeFirstLetter(props.label) || ''}
          </div>
        </div>
      </Form.Group>
    </>
  );
};

export default StandardCheckbox;
